import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import { removeCurrencyTemplate } from 'store/entities/company-settings/company-settings';
import translations from 'src/internationalisation/translation-map.json';

const CurrencyTemplateDeleteModal = ({ setModalVisible, removeCurrencyTemplate, currencyTemplateId }) => {
  const { t } = useTranslation();
  const onClose = () => setModalVisible(false);

  const onDelete = () => {
    removeCurrencyTemplate(currencyTemplateId);
    setModalVisible(false);
  };

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: `${t(translations.delete)} ${t(translations.currency_template)}`,
          content: <>{t(translations.delete_currency_template_confirmation)}</>,
          footer: (
            <>
              <Button label={t(translations.delete)} colored onClick={onDelete} />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapDispatchToProps = { removeCurrencyTemplate };
const Container = connect(null, mapDispatchToProps)(CurrencyTemplateDeleteModal);

export { Container as CurrencyTemplateDeleteModal };
